import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import { RUI_FIELD_LABEL_ATTR } from "../form/control-protocol";
export function RuiLabel({
  children,
  htmlFor,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("label", {
    ...props,
    ...{
      [RUI_FIELD_LABEL_ATTR]: ""
    },
    class: cx("rui-label", className),
    htmlFor,
    children
  });
}